<template>
  <a-modal
    :visible="visible"
    :width="width"
    @cancel="$emit('close')"
  >
    <template #footer>
      <a-button key="submit">
        <a :href="documentUrl" target="_blank" rel="noopener">Download</a>
      </a-button>
    </template>
    <div style="margin-top: 20px">
      <div v-if="isPdf" style="text-align: center; padding: 40px 0;">
        <p>This PDF cannot be previewed here.</p>
        <!-- <a :href="documentUrl" target="_blank" rel="noopener" style="color: #2563eb; font-weight: 500">
          Open PDF in new tab
        </a> -->
      </div>
      <div v-else-if="isImage" class="image-container">
        <img
          :src="documentUrl"
          class="preview-image"
          alt="Document preview"
        />
      </div>
      <iframe
        v-else
        :src="documentUrl"
        style="width: 100%; height: 70vh; border: none"
        frameborder="0"
      />
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "DocumentPreviewModal",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    documentUrl: {
      type: String,
      required: true,
    },
    width: {
      type: [String, Number],
      default: 800,
    },
  },
  computed: {
    isImage() {
      // crude check for image extension
      return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(this.documentUrl);
    },
    isPdf() {
      return /\.pdf(\?|$)/i.test(this.documentUrl);
    },
  },
};
</script>

<style scoped>
.image-container {
  max-height: 70vh;
  overflow: auto;
  text-align: center;
  background: #f5f5f5;
  border-radius: 6px;
  padding: 16px;
}

.preview-image {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: white;
}

/* For very small images, don't scale them up */
.preview-image {
  min-width: auto;
  min-height: auto;
}
</style> 